// eslint-disable-next-line import/prefer-default-export
export const DOMAINS = 'COMMON/DOMAINS'
export const ADMIN = 'ADMIN'
export const COUNTRIES_AREAS = 'COUNTRIES_AREAS'

// 国际化
export const CHANGE_LANGUAGE = 'I18N/CHANGE_LANGUAGE'
export const CHANGE_LANGUAGE_SUCCESS = 'I18N/CHANGE_LANGUAGE_SUCCESS'

// 用户相关
// 登录
export const CHANGE_LOGIN = 'CHANGE_LOGIN'
export const CHANGE_EXAMINETYPE = 'CHANGE_EXAMINETYPE'
export const CHANGE_LOGINVISIBLE = 'CHANGE_LOGINVISIBLE'
export const CHANGE_USERINFO = 'CHANGE_USERINFO'
export const CHANGE_LANG = 'CHANGE_LANG'
export const LOGIN_REQUEST = 'USER/LOGIN_REQUEST' // 用户登录请求
export const LOGIN_START = 'USER/LOGIN_START' // 用户登录
export const LOGIN_SUCCESS = 'USER/LOGIN_SUCCESS' // 用户登录成功
export const LOGIN_ACCOUNT_OR_PASSWORD_ERROR = 'USER/LOGIN_ACCOUNT_OR_PASSWORD_ERROR'
export const LOGIN_TIMEOUT = 'USER/LOGIN_TIMEOUT'
export const RESET_ERROR = 'USER/RESET_ERROR'
export const LOGIN_CANCEL = 'USER/LOGIN_CANCEL'
export const LOGIN_MODAL_VISIBLE = 'USER/LOGIN_MODAL_VISIBLE'
// 刷新浏览器
export const REFRESH_BROWSER = 'USER/REFRESH_BROWSER'
// 查询用户详细信息
export const INITIAL_USER_INFO = 'USER/INITIAL_USER_INFO'
export const GET_USER_INFO = 'USER/GET_USER_INFO'
export const GET_USER_INFO_SUCCESS = 'USER/GET_USER_INFO_SUCCESS'
// 查询用户认证状态
export const GET_DEVELOPER_INFO_SUCCESS = 'USER/GET_DEVELOPER_INFO_SUCCESS'
// 退出登录
export const LOGINOUT = 'USER/LOGINOUT'
export const LOGINOUT_SUCCESS = 'USER/LOGINOUT_SUCCESS'
export const LOGINOUT_FAIL = 'USER/LOGINOUT_FAIL'
// 注册
export const INITIAL_REGISTER_INFO = 'USER/INITIAL_REGISTER_INFO'
export const REGISTER_START = 'USER/REGISTER_START'
export const REGISTER = 'USER/REGISTER'
export const REGISTER_END = 'USER/REGISTER_END'
// 申请认证
export const APPLY_FOR_VERIFY = 'USER/APPLY_FOR_VERIFY'
// 修改语言
export const CHANGE_USER_LANGUAGE = 'USER/CHANGE_LANGUAGE'
// 修改菜单权限
export const CHANGE_DISPLAY_MENU = 'CHANGE_DISPLAY_MENU'
